var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = { showNav: true, timeLineStep: 1 };
var AppSliceState = createSlice({
    name: 'app',
    initialState: initialState,
    reducers: {
        showNavigation: function (state, action) {
            state.showNav = action.payload;
        },
        setTimeLineStep: function (state, action) {
            state.timeLineStep = action.payload;
        }
    }
});
export var showNavigation = (_a = AppSliceState.actions, _a.showNavigation), setTimeLineStep = _a.setTimeLineStep;
export default AppSliceState.reducer;
